<template>
  <div class="log-container">
    <el-card shadow="hover">
      <div class="filter-bar">
        <!-- <el-date-picker
          v-model="dateRange"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          @change="fetchLogs">
        </el-date-picker> -->

        <el-input
          v-model="searchKey"
          placeholder="搜索用户ID/IP"
          style="width: 240px; margin-bottom: 10px;"
          @keyup.enter="fetchLogs">
          <template #append>
            <el-button icon="el-icon-search" @click="fetchLogs" />
          </template>
        </el-input>
      </div>
   
      <el-table 
        :data="logData" 
        border 
        stripe 
        v-loading="loading"
        style="width: 100%; min-width: 1200px">
        
        <el-table-column 
          prop="id" 
          label="ID" 
          width="70"
          sortable>
        </el-table-column>

        <el-table-column prop="user_id" label="用户ID" ></el-table-column>
        
        <el-table-column prop="event_type" label="事件类型">
          <template #default="{row}">
            <!-- :type="eventTypeTag(row.event_type)" -->
            <el-tag  >
              {{ eventTypeCN[row.event_type] || row.event_type }}
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column prop="ip_address" label="IP地址"></el-table-column>
        
        <el-table-column prop="device_fingerprint" label="设备指纹" >
          <template #default="{row}">
            <el-tooltip effect="dark" :content="row.device_fingerprint" placement="top">
              <span class="text-ellipsis">{{ row.device_fingerprint.slice(0, 15) }}...</span>
            </el-tooltip>
          </template>
        </el-table-column>

        <el-table-column prop="risk_level" label="风险等级">
          <template #default="{row}">
            <el-tag :type="row.risk_level" effect="dark">
              <!-- {{ riskLevelText(row.risk_level) }} -->
              {{ row.risk_level }}
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column prop="event_time" label="时间" sortable>
          <template #default="{row}">
            <!-- {{ formatTime(row.event_time) }} -->
            {{ row.event_time }}
          </template>
        </el-table-column>

        <!-- <el-table-column label="操作" width="120">
          <template #default="{row}">
            <el-button 
              size="mini" 
              type="primary" 
              @click="showDetail(row)">
              详情
            </el-button>
          </template>
        </el-table-column> -->
      </el-table>


        <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        background :current-page="currentPage"
        :page-sizes="[20, 100,500, 1000]"
        layout="total,sizes, prev, pager, next, jumper"
        :total="totalDataNumber"></el-pagination>
  
    </el-card>

    <!-- <log-detail-dialog 
      :visible="detailVisible"
      :detailData="currentDetail"
      @close="detailVisible = false">
    </log-detail-dialog> -->
  </div>
</template>

<script>
import LogApi from '@/api/log.js';
export default {
  data() {
    return {
      logData: [],
      currentPage: 1,
      pageSize: 20,
      totalDataNumber: 0,
      dateRange: [],
      searchKey: '',
      loading: false,
      detailVisible: false,
      currentDetail: null,
      eventTypeCN: {
        'login': '登录事件',
        'logout': '登出事件',
        'access_denied': '访问拒绝',
        'password_change': '密码修改',
        'permission_change': '权限变更',
        'unauthorized_operation': '未授权操作',
        'brute_force_attempt': '暴力破解尝试',
        'sensitive_operation': '敏感操作',
        'abnormal_behavior': '异常行为'
      }

    }
  },
  created() {

    this.fetchLogs();
  },
  methods: {
     /*选择第几页*/
     handleCurrentChange(val) {
      this.currentPage = val
      this.getTableList()
    },
    /*每页多少条*/
    handleSizeChange(val) {
      this.currentPage = 1
      this.pageSize = val
      this.getTableList()
    },
     fetchLogs() {
      var self = this;
      this.loading = true
      try {
        const params = {
          page: this.currentPage,
          size: this.pageSize,
          // even_time: this.dateRange,
          search: this.searchKey
        }

        LogApi.getSecurityLog(params, true)
        .then(data => {
          self.loading = false;
          self.logData =data.data.list.data;
          self.totalDataNumber = data.data.list.total;
        })
        .catch(error => {});
      } finally {
        this.loading = false
      }
    },
    // ...其他方法保持不变
  }
}
</script>



// WEBPACK FOOTER //
// src/views/auth/securitylog/index.vue